import { schema } from "normalizr";

const question = new schema.Entity("question");
const questions = [question];

export default questions;



// WEBPACK FOOTER //
// ./src/schemas/question.js